import { IconStarFill } from '@macarongfactory/web-icons'
import { Text } from '@macarongfactory/web-ui'

interface IStarRatingProps {
  /** 평점 (1~5) */
  rating: number
  /** 별 아이콘 크기(px) — 기본 16 */
  size?: number
  /** 평점 숫자 동반 표기 여부 */
  showValue?: boolean
}

/** 별 총 개수 */
const TOTAL_STARS = 5

/**
 * 별점 표시 — 점수의 소수점만큼 별을 부분 채움(예: 4.5 → 4개 + 반개).
 * 각 별은 빈 별(neutral-muted)을 바닥에 깔고, 그 위에 채워진 별(caution)을
 * 해당 칸 채움 비율(0~1)만큼 좌측에서 클립해 겹친다.
 * 요약 카드(14px)와 후기 행(16px)에서 공용으로 사용한다.
 */
const StarRating = ({
  rating,
  size = 16,
  showValue = false,
}: IStarRatingProps) => {
  return (
    <div className='flex items-center gap-dimension-x0-5'>
      {Array.from({ length: TOTAL_STARS }, (_, index) => {
        // 이 별 칸의 채움 비율 (0~1) — rating이 4.5면 5번째 칸은 0.5
        const fillFraction = Math.min(Math.max(rating - index, 0), 1)
        return (
          <div
            key={index}
            className='relative shrink-0'
            style={{ width: size, height: size }}
          >
            {/* 빈 별 (바닥) */}
            <IconStarFill
              width={size}
              height={size}
              className='absolute inset-0 text-foreground-neutral-muted'
            />
            {/* 채워진 별 — 비율만큼 좌측에서 클립해 겹침 */}
            {fillFraction > 0 ? (
              <div
                className='absolute inset-y-0 left-0 overflow-hidden'
                style={{ width: `${fillFraction * 100}%` }}
              >
                <IconStarFill
                  width={size}
                  height={size}
                  className='block max-w-none text-foreground-caution-strong'
                />
              </div>
            ) : null}
          </div>
        )
      })}
      {showValue ? (
        <Text variant='title-2-semibold' color='text-foreground-caution-strong'>
          {rating}
        </Text>
      ) : null}
    </div>
  )
}

export default StarRating
